import React, { useState, useEffect } from 'react';
import '../styles/InstallPrompt.css';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setDeferredPrompt(e);
      // Update UI notify the user they can add to home screen
      // Wait a bit before showing to not annoy immediately
      setTimeout(() => {
        const isInstalled = window.matchMedia('(display-mode: standalone)').matches;
        const isDismissed = localStorage.getItem('installPromptDismissed');
        
        if (!isInstalled && !isDismissed) {
          setIsVisible(true);
        }
      }, 5000);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    // Show the prompt
    deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User response to the install prompt: ${outcome}`);
    
    // We've used the prompt, and can't use it again, throw it away
    setDeferredPrompt(null);
    setIsVisible(false);
  };

  const handleDismiss = () => {
    setIsVisible(false);
    // Don't show again for 7 days
    localStorage.setItem('installPromptDismissed', Date.now());
  };

  // Re-check dismissal - if it was dismissed more than 7 days ago, show again
  useEffect(() => {
    const checkDismissal = () => {
      const dismissedTime = localStorage.getItem('installPromptDismissed');
      if (dismissedTime) {
        const threeDays = 3 * 24 * 60 * 60 * 1000;
        if (Date.now() - parseInt(dismissedTime) > threeDays) {
          localStorage.removeItem('installPromptDismissed');
        }
      }
    };
    checkDismissal();
  }, []);

  if (!isVisible) return null;

  return (
    <div className={`install-prompt-overlay ${isVisible ? 'show' : ''}`}>
      <div className="install-prompt-card">
        <button className="install-close-btn" onClick={handleDismiss}>
          <span className="material-symbols-outlined">close</span>
        </button>
        
        <div className="install-icon-wrapper">
           <img src="/logo4.png" alt="Bi Teklifle Logo" className="install-app-icon" />
        </div>
        
        <div className="install-content">
          <h4>Uygulamamızı İndirin</h4>
          <p>Daha hızlı erişim ve anlık bildirimler için Bi Teklifle'yi ana ekranınıza ekleyin.</p>
        </div>
        
        <div className="install-actions">
          <button className="install-btn-primary" onClick={handleInstallClick}>
            Uygulamayı Yükle
          </button>
          <button className="install-btn-secondary" onClick={handleDismiss}>
            Daha Sonra
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPrompt;
